import { Box } from '@mui/material';
import cn from 'classnames';
import { observer } from 'mobx-react';

import cameraRotateIcon from 'src/assets/icons/cameraGreen.svg';
import keyIcon from 'src/assets/icons/keyRed.svg';
import penIcon from 'src/assets/icons/penYellow.svg';
import languageIcon from 'src/assets/icons/switchLanguage.svg';
import LanguagePicker from 'src/components/controls/app-bar/components/LanguagePicker/index';
import useStores from 'src/hooks/useStores';
import { useLocale } from 'src/providers/LocaleProvider';

import { useModalControls } from '../../hooks/useModalControls';
import { EUserSettigs } from '../../type/type';

import SettingItem from './SettingItem';
import { useStyles } from './styles';

const UserSettings = () => {
    const styles = useStyles();
    const { generalStore } = useStores();
    const {
        profile: {
            gameSettings: {
                changeAvatar,
                changePassword,
                changeNickname,
                changeLanguage,
            },
        },
    } = useLocale();

    const { changeModalState } = useModalControls();

    return (
        <Box component='div' className={cn(styles.wrapper, EUserSettigs.USER_ENG)}>
            <Box component='div' className={styles.groupBox}>
                <SettingItem
                    text={changeAvatar('Change Avatar')}
                    icon={cameraRotateIcon}
                    onClick={() => {
                        changeModalState('changeAvatar', true);
                    }}
                />
                {generalStore.isDicechessMode && (
                    <>
                        <SettingItem
                            text={changePassword('Change Password')}
                            icon={keyIcon}
                            onClick={() => {
                                changeModalState('changePassword', true);
                            }}
                        />
                        <SettingItem
                            text={changeNickname('Change nickname')}
                            icon={penIcon}
                            onClick={() => {
                                changeModalState('changeNickname', true);
                            }}
                        />
                    </>
                )}
                <Box component='div' className={styles.boxChangeLanguage}>
                    <img
                        className={styles.settingLangItemImg}
                        src={languageIcon}
                        alt='lang'
                    />
                    <p className={styles.settingItemText}>
                        {changeLanguage('Change Language:')}
                    </p>
                    <Box component='div' className={styles.boxLanguagePeaker}>
                        <LanguagePicker />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default observer(UserSettings);
